import { useState, useEffect } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import api from "../../utils/api";

const SIDE_COLORS = { Front: "#0d6efd", Back: "#6f42c1", Other: "#adb5bd" };
const FORMAT_COLORS = { "GS1 Digital Link": "#20c997", Standard: "#fd7e14", Legacy: "#6c757d" };

const Donut = ({ data, colors, title }) => {
  const total = data.reduce((s, d) => s + d.count, 0);
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <h6 className="text-center mb-0" style={{ fontSize: "12px" }}>{title}</h6>
      {total === 0 ? (
        <p className="text-muted text-center small mt-4">No data</p>
      ) : (
        <ResponsiveContainer width="100%" height={170}>
          <PieChart>
            <Pie data={data} dataKey="count" nameKey="name" cx="50%" cy="50%" innerRadius={35} outerRadius={60}
              label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`} labelLine={false} style={{ fontSize: "10px" }}>
              {data.map((d) => <Cell key={d.name} fill={colors[d.name] || "#999"} />)}
            </Pie>
            <Tooltip formatter={(v, n) => [v.toLocaleString(), n]} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const ScanMixChart = ({ queryParams }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/api/analytics/scan-mix?${queryParams}`).then((r) => setData(r.data)).catch(console.error).finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  if (!data) return <p className="text-muted text-center">No data</p>;

  const { scanners, gs1, channel } = data;
  const repeatPct = scanners.uniqueIps ? Math.round((100 * scanners.repeatIps) / scanners.uniqueIps) : 0;
  const gs1Total = gs1.withChannel + gs1.withoutChannel;

  return (
    <div>
      <div className="d-flex gap-2">
        <Donut data={data.side} colors={SIDE_COLORS} title="Front vs Back" />
        <Donut data={data.format} colors={FORMAT_COLORS} title="Code Format" />
      </div>
      <div className="row text-center mt-2" style={{ fontSize: "12px" }}>
        <div className="col-4">
          <div className="fw-bold" style={{ fontSize: "16px" }}>{scanners.uniqueIps.toLocaleString()}</div>
          <div className="text-muted" title="Distinct IP addresses (approximation: carrier networks share addresses)">Unique scanners</div>
        </div>
        <div className="col-4">
          <div className="fw-bold" style={{ fontSize: "16px" }}>{repeatPct}%</div>
          <div className="text-muted" title={`${scanners.repeatIps.toLocaleString()} addresses scanned more than once`}>Repeat rate</div>
        </div>
        <div className="col-4">
          <div className="fw-bold" style={{ fontSize: "16px" }}>{gs1Total ? Math.round((100 * gs1.withoutChannel) / gs1Total) : 0}%</div>
          <div className="text-muted" title="GS1 scans arriving without the ch= parameter: the query string was stripped by a retailer app or GS1-aware scanner">GS1 via apps</div>
        </div>
      </div>
      {channel.length > 0 && (
        <div className="mt-2" style={{ fontSize: "11px" }}>
          <span className="text-muted">GS1 by channel: </span>
          {channel.map((c) => <span key={c.name} className="badge bg-light text-dark border me-1">{c.name} {c.count.toLocaleString()}</span>)}
        </div>
      )}
    </div>
  );
};

export default ScanMixChart;
